import React, { useContext } from "react"

import { X } from "@phosphor-icons/react"
import { Dialog, DialogPanel } from "@headlessui/react"

import UserContext from "@context/UserContext"
import WelcomeBack from "@components/modal/User/Login/WelcomeBack"
import UserAuth from "@components/modal/User/UserAuth"

const LoginModal = ({ data, isOpen = false, showRegisterForm = false, onClose = () => {}}) => {
    const openState = isOpen || false
    const { loginSuccess, setLoginSuccess } = useContext(UserContext)

    const handleOnClose = () => {
        setLoginSuccess(false)
        onClose()
    }

    return (
        <React.Fragment>
            <Dialog open={openState} onClose={handleOnClose} className="relative z-[100]">
                <div className="fixed inset-0 w-screen overflow-y-auto p-4 bg-black bg-opacity-60">
                    <div className="flex min-h-full items-center justify-center">
                        <DialogPanel className={`relative border bg-white ${!loginSuccess && 'w-screen md:w-[640px] p-6'} overflow-y-auto minimalist-scrollbar gap-6`}>
                            <X
                                className="absolute top-0 right-0 cursor-pointer text-black m-2 bg-white bg-opacity-15 rounded-sm p-1.5"
                                size={44}
                                weight="light"
                                onClick={onClose}
                            />

                            <div className="w-full flex">
                                {loginSuccess ? (
                                    <WelcomeBack handleClose={handleOnClose} />
                                ) : (
                                    <UserAuth showRegisterForm={showRegisterForm} className='' />
                                )}
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
}

export default LoginModal
